import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-extended',
    templateUrl: './extended.component.html',
    styleUrls: ['./extended.component.scss'],
    standalone: false
})
export class ExtendedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
